import { render, staticRenderFns } from "./HospitalsData.vue?vue&type=template&id=602a4aba"
import script from "./HospitalsData.vue?vue&type=script&lang=js"
export * from "./HospitalsData.vue?vue&type=script&lang=js"
import style0 from "./HospitalsData.vue?vue&type=style&index=0&id=602a4aba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports